import { render, staticRenderFns } from "./ListPriceLists.vue?vue&type=template&id=fc71de90&scoped=true"
import script from "./ListPriceLists.vue?vue&type=script&lang=js"
export * from "./ListPriceLists.vue?vue&type=script&lang=js"
import style0 from "./ListPriceLists.vue?vue&type=style&index=0&id=fc71de90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc71de90",
  null
  
)

export default component.exports